import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React from 'react';

export default function EarningsTable() {
  const itemTableColumns: GridColDef[] = [
    {
      field: 'Earning',
      headerName: 'Earning',
      flex: 2,
      sortable: false,
      renderCell: (params) => (

        <Typography variant="body2" component="p">
          {params.value}
        </Typography>

      ),
    },
    {
      field: 'Transaction type',
      headerName: 'Transaction type',
      flex: 3,
      sortable: false,
    },
    {
      field: 'Date',
      headerName: 'Date',
      flex: 1.25,
      sortable: false,
    },
    {
      field: 'Total earnings',
      headerName: 'Total earnings',
      flex: 1,
      sortable: false,

      minWidth: 175,
    },
  ];
  return (
    <div>
      {/* <CustomTable
        rows={}
        columns={itemTableColumns}
        checkboxSelection={false}
        rowIdProperty="id"
        hideFooter={false}
        pagination
        rowsPerPageOptions={5}
        pageSize={5}
        paginationMode="server"
      /> */}
    </div>
  );
}
